/**
 * 不在客户端内，模拟打开弹窗
 * @param url
 * @param w
 * @param h
 */
export const openWindow = (url: string, w: number, h: number) => {
  let dualScreenLeft: number = window.screenLeft;
  let dualScreenTop: number = window.screenTop;
  let left: number = window.innerWidth / 2 - w / 2 + dualScreenLeft;
  let top: number = window.innerHeight / 2 - h / 2 + dualScreenTop;
  let features = `
    toolbar=no,
    location=no,
    directories=no,
    status=no,
    menubar=no,
    scrollbars=no,
    resizable=yes,
    copyhistory=no,
    width=${w},
    height=${h},
    top=${top}
    left=${left}
  `;
  window.open(url, "_blank", features);
}

